import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import Axios from 'axios';

export const AXIOS_INSTANCE = Axios.create({ baseURL: '/' }); // use your own URL here or environment variable

const csrfToken = document.getElementsByName(
  'csrfmiddlewaretoken',
  // @ts-expect-error non standard value
)?.[0]?.value;

AXIOS_INSTANCE.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-CSRFToken': csrfToken,
};

// add a second `options` argument here if you want to pass extra options to each generated query
export const customInstance = <T>(
  config: AxiosRequestConfig,
): Promise<AxiosResponse<T, unknown>> => {
  return AXIOS_INSTANCE<T>(config);
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;
